import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import MaterialKit from "./plugins/material-kit";

Vue.config.productionTip = false;

import VueScrollTo from "vue-scrollto";

Vue.use(VueScrollTo);

// You can also pass in the default options
Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: 0,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 });

Vue.use(MaterialKit);

const NavbarStore = {
  showNavbar: false
};

Vue.mixin({
  data() {
    return {
      NavbarStore
    };
  }
});

// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";

import "firebase/analytics";

var firebaseConfig = {
  apiKey: "AIzaSyDpW-It6HKVjahdiGv2nQnygzYVTzdgoDQ",
  authDomain: "softultra-web.firebaseapp.com",
  databaseURL: "https://softultra-web.firebaseio.com",
  projectId: "softultra-web",
  storageBucket: "softultra-web.appspot.com",
  messagingSenderId: "111374033256",
  appId: "1:111374033256:web:3ae81706fdf2da081df6dd",
  measurementId: "G-NNP8FV9HLJ"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();


new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
